export default __webpack_public_path__ + "static/media/roleicon.50eed1cf.svg";